module.exports = __webpack_public_path__ + "static/media/netstrada.48455994.svg";